import React from 'react';
import { FiLogOut } from 'react-icons/fi';
import classes from './logoutModal.module.css';


const LogoutModal = ({  }) => {
 
  return (
    <div className={classes.modalBackdrop}>
      <div className={classes.modalBox}>
        <div className={classes.iconWrapper}>
          <FiLogOut className={classes.icon} />
        </div>
        <h2 className={classes.title}>Logout</h2>
        <p className={classes.subtext}>
          Are you sure you want to logout? You will need to log in again to access your account.
        </p>
        <div className={classes.modalActions}>
          <button  className={classes.cancelBtn}>Cancel</button>
          <button  className={classes.logoutBtn}>Logout</button>
        </div>
      </div>
    </div>
  );
};

export default LogoutModal;



